import React, { useState } from 'react'
import FormCreator from '../../../../../components/finalForms/FormCreator'

/**css */
import '../../../../inventory/Inventory.scss'
import { ReceiveReturnAcqisitionfilterFormData } from './ReceiveReturnAcqisitionfilterFormData'
import { findFieldsById } from '../../../../../utils/formFieldUtils/ManageFields'

const ReceiveReturnAcqisitionfilter = () => {
    const [receiveReturnAcqisitionfilterForm, setReceiveReturnAcqisitionfilterForm] = useState(ReceiveReturnAcqisitionfilterFormData)

    const handleOnChnage = (dataField, updatedFormData) => {
        if (dataField === 'isPOshow') {
            let poField = findFieldsById(receiveReturnAcqisitionfilterForm, "lSupplierPOKey");
            poField.fieldSetting.isDisable = !updatedFormData.isPOshow;
            setReceiveReturnAcqisitionfilterForm({ ...receiveReturnAcqisitionfilterForm });
        }
    }
    return (
        <div className='row'>
            <div className="min-width-purchase-order p-1">
                <div className="row form-card justify-content-between">
                    <FormCreator
                        config={receiveReturnAcqisitionfilterForm}
                        onColumnChange={handleOnChnage}
                    />
                </div>
            </div>
        </div>
    )
}

export default ReceiveReturnAcqisitionfilter